import type BaseEnumType from "@/app/services/baseEnumType";
import type { Maybe } from "@/components/utils/typeHelpers";
import type { BmIconName } from "@/components/controls/bmIconMap";

export default class EnumUserPermissionAccess implements BaseEnumType {
  private static allValues: EnumUserPermissionAccess[] = [];

  public static noAccess = new EnumUserPermissionAccess(
    0,
    "NoAccess",
    "user_roles_no_access",
    "Close",
    "error"
  );
  public static readOnly = new EnumUserPermissionAccess(
    1,
    "ReadOnly",
    "user_roles_read_only",
    "Visibility",
    "grey lighten-1"
  );
  public static fullAccess = new EnumUserPermissionAccess(
    2,
    "FullAccess",
    "user_roles_full_access",
    "Check",
    "success lighten-3"
  );

  public key: number;
  public value: string;
  public translationKey: string;
  public icon: BmIconName;
  public colour: string;

  private constructor(
    key: number,
    value: string,
    translationKey: string,
    icon: BmIconName,
    colour: string
  ) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    this.icon = icon;
    this.colour = colour;
    EnumUserPermissionAccess.allValues.push(this);
  }

  public equals(other: Maybe<EnumUserPermissionAccess>): boolean {
    return this.key === other?.key;
  }

  public isNoAccess() {
    return this.equals(EnumUserPermissionAccess.noAccess);
  }
  public isReadOnly() {
    return this.equals(EnumUserPermissionAccess.readOnly);
  }
  public isFullAccess() {
    return this.equals(EnumUserPermissionAccess.fullAccess);
  }

  public static getValues(): EnumUserPermissionAccess[] {
    return EnumUserPermissionAccess.allValues;
  }

  public static getByKey(key: number): EnumUserPermissionAccess {
    const found = EnumUserPermissionAccess.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUserPermissionAccess - Key not found: ${key}`);
    }

    return found;
  }
}
